// Recipient Email Validation
// This script intercepts form submission to validate recipient email field

document.addEventListener('DOMContentLoaded', function() {
  const recipientEmailInput = document.getElementById("recipients-email");
  
  // Only run if recipient email field exists
  if (!recipientEmailInput) {
    return;
  }

  // Find the product form
  const productForm = document.querySelector('product-form form');
  if (!productForm) {
    return;
  }

  // Hide error message when user clicks on the email field
  recipientEmailInput.addEventListener('focus', function() {
    hideRecipientEmailError();
  });

  // Intercept form submission
  productForm.addEventListener('submit', function(event) {
    if (!validateRecipientEmail()) {
      event.preventDefault();
      event.stopPropagation();
      return false;
    }
  }, true);
});

function validateRecipientEmail() {
  const recipientEmailInput = document.getElementById("recipients-email");
  
  if (!recipientEmailInput) {
    return true;
  }

  const emailValue = recipientEmailInput.value.trim();
  
  // Check if field is empty
  if (emailValue === "") {
    showRecipientEmailError("**Please enter the recipient's email address");
    return false;
  }

  // Validate email format
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(emailValue)) {
    showRecipientEmailError("**Please enter a valid email address");
    return false;
  }

  return true;
}

function showRecipientEmailError(message) {
  // Use the existing product form error message wrapper
  const productForm = document.querySelector('product-form');
  if (!productForm) return;
  
  const errorWrapper = productForm.querySelector('.product-form__error-message-wrapper');
  const errorMessage = productForm.querySelector('.product-form__error-message');
  
  if (errorWrapper && errorMessage) {
    errorMessage.textContent = message;
    errorWrapper.removeAttribute('hidden');
  }
}

function hideRecipientEmailError() {
  // Use the existing product form error message wrapper
  const productForm = document.querySelector('product-form');
  if (!productForm) return;
  
  const errorWrapper = productForm.querySelector('.product-form__error-message-wrapper');
  const errorMessage = productForm.querySelector('.product-form__error-message');
  
  if (errorWrapper && errorMessage) {
    errorWrapper.setAttribute('hidden', '');
    errorMessage.textContent = '';
  }
}

